import { canonicalSimSearch } from "@aerofox/shared/legacy-ids";
import { visitAllowed, visitRequest } from "@aerofox/shared/visit-metrics";

// 入口:按 ?replay / ?mode / ?aircraft / ?lesson 选择回放播放页(ADR-046)、应急课(客机)、教练机基础课(课程 id 以 trainer- 开头,curriculum 的测试守护)、
// 教练机或客机自由飞行。各自动态加载,互不拖累首包。
//
// 旧链接(ADR-053):`lesson=c172-*` / `b737-*`、`aircraft=737`、`airport=cykf` / `cytz` 先按 `@aerofox/shared/legacy-ids` 的别名表
// 换成新值,并用 replaceState 改写地址栏(不新增历史记录),之后各页面读到的都是新参数,分享出去的也是新链接。
const canonical = canonicalSimSearch(location.search);
if (canonical !== null) history.replaceState(history.state, "", `${location.pathname}${canonical}${location.hash}`);
const params = new URLSearchParams(location.search);
// 到访的匿名计数(PRD 模块 BJ、ADR-118):模拟器页每次整页加载报一条,只带界面语言(没有 cookie、网址或标识符;开着「请勿跟踪」的不报;失败静默)。
if (visitAllowed(navigator as Navigator & { globalPrivacyControl?: boolean })) {
  const req = visitRequest((import.meta.env.VITE_API_URL as string | undefined) ?? "", document.documentElement.lang);
  if (req) void fetch(req.url, req.init).catch(() => undefined);
}
// ?replay=<key>:分享的回放(ADR-046);?demo=<课程>:课程示范(ADR-126,同一个播放页)。优先于其他参数。
if (params.has("replay") || params.has("demo")) await import("./replay-main");
else if (params.get("mode") === "atlas") await import("./atlas-main");
else if (params.get("mode") === "free" && params.get("aircraft") === "airliner") await import("./jet-main");
else if (params.get("lesson")?.startsWith("trainer-")) await import("./trainer-main");
else if (params.get("mode") === "free") await import("./flight-main");
else await import("./lesson-main");

export {};
